import {initializeApp} from 'firebase/app';
import {getFirestore} from 'firebase/firestore';
import FirebaseConfig from '../config/firebaseConfig';

const app = initializeApp(FirebaseConfig)
const db = getFirestore(app)

export default db